import { callService } from '../tools';

export const verificarEmail = (correo, disp) => {
    console.log("VM: " + correo);
    console.log("VM: " + disp);
    return dispatch => {
        dispatch({
            "type": "OLVIDE_SET_FLAG_ERROR",
            "flag": false
        });
        new callService({
            service: 'olvideContrasena.restablecerPass',
            "secure": true,
            data: { correo: correo }
        }).execute().then(body => {
            respuestaExito(dispatch, body, correo, disp);
        }).catch(error => {
            respuestaError(dispatch, error);
        });
    }
}

export const respuestaExito = (dispatch, body, correo, disp) => {
    console.log("body olvide", body);
    console.log("correo", correo);

    if (body.hasOwnProperty('error')) {
        dispatch({ "type": "LOADER_HIDE" });
        dispatch({
            "type": "MODAL_ALERT_MESSAGES_SHOW",
            "titulo": "Error", "mensaje": "Tuvimos un error"
        });
    } else {

        if (body.correlationId !== "") {
            new callService({
                service: "registro.incConsultaRegistro",
                "secure": true,
                data: { "correo": correo.toLowerCase() }
            }).execute().then((respuesta) => {
                console.log("respuesta ingresaCorreo incConsultaRegistro:", respuesta, correo);
                if (respuesta.banConcluirReg.toString() === 'false') {
                    localStorage.setItem("banConcluirReg", respuesta.banConcluirReg);
                    localStorage.setItem("correoInconcluso", correo);
                    localStorage.setItem("correoModal", correo);

                    dispatch({ "type": "LOADER_HIDE" });
                    goTo("gnp/registro");

                } else {
                    localStorage.removeItem("banConcluirReg");

                    dispatch({ "type": "LOADER_HIDE" });
                    dispatch({ "type": "EVENT_OLVIDE_ENVIAR-CORRECTOS", "dispositivo": disp });
                    dispatch({ "type": "OLVIDE_PASO_SIGUIENTE" });
                }
            }).catch((error) => {
                console.log("Error??", error);

                dispatch({ "type": "LOADER_HIDE" });
                dispatch({ "type": "EVENT_OLVIDE_ENVIAR-CORRECTOS", "dispositivo": disp });
                dispatch({ "type": "OLVIDE_PASO_SIGUIENTE" });
            });
        } else {
            dispatch({ "type": "LOADER_HIDE" });
            console.log("hubo un error");
        }
    }
}

export const respuestaError = (dispatch, error) => {
    console.log("Error olvide", error);

    dispatch({ "type": "LOADER_HIDE" });

    if ((error.hasOwnProperty('body') || error.hasOwnProperty('message')) && (error.body.codigoError === "ERROR_AUT003"
        || error.message.codigoError === "eCl00014" || error.message.codigoError === "eCl00088")) {
        dispatch({
            "type": "OLVIDE_SET_MENSAJE_ERROR",
            "mensaje": "Lo sentimos, el correo electrónico proporcionado no está registrado."
        });
        dispatch({
            "type": "OLVIDE_SET_FLAG_ERROR",
            "flag": true
        });
    } else if (error.inactivo) {
        dispatch({ "type": "LOADER_HIDE" });
        dispatch({ "type": "OLVIDE_SET_PASO", "paso": "bloqueado" });
    } else if (error.message.codigoError === "eCl00014" && error.message.mensajeTecnico.includes("CTGIMH020E")) {
        dispatch({
            "type": "OLVIDE_SET_MENSAJE_ERROR",
            "mensaje": "Lo sentimos, por su seguridad no puede introducir contraseñas anteriores."
        });
    }
    else {
        dispatch({
            "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Error",
            "mensaje": "Hubo un error al generar la Url. Favor de intentar más tarde."
        });
    }
}



// WEBPACK FOOTER //
// ./src/gnp-olvide/services.act.js